import { makeStaticProps } from '@ui/lib/i18n/build-time';
import { ns } from '@ui/lib/i18n/i18n.config';

export { Page as default } from '@ui/views/Leaderboard';

// required for default translation
const getStaticProps = makeStaticProps(ns);
export { getStaticProps };

